export default {
  name: "text",
  components: {},
  props: ["scale", "element", "color", "styles"],
  data() {
    return {
      classObject: {
        h1: this.scale === "h1",
        h2: this.scale === "h2",
        h3: this.scale === "h3",
        h4: this.scale === "h4",
        h5: this.scale === "h5",
        h6: this.scale === "h6",
        caption: this.scale === "caption",
        body: this.scale === "body",
        "body-2": this.scale === "body-2",
        navy: this.color === "navy",
        blue: this.color === "blue",
        grey: this.color === "grey",
        "dark-grey": this.color === "dark-grey"
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
